const items = [
  "Company Primer",
  "Valuation Models",
  "Proxy Review",
  "Risk Tracker",
  "Historical & Peer Comps",
  "Earnings Recap & Guidance",
  "Management Follow-ups",
  "Thesis Dashboard",
];

const Track = () => (
  <div className="flex items-center gap-8 pr-8">
    {items.map((item) => (
      <span key={item} className="flex items-center gap-8">
        <span>{item}</span>
        <span aria-hidden="true">&bull;</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  return (
    <div
      data-testid="modules-marquee"
      aria-label="Research modules"
      className="py-4 border-b border-grove-bsub bg-grove-wash overflow-hidden"
    >
      <div className="eq-mq-track font-mono text-xs uppercase tracking-widest text-grove-mid">
        <Track />
        <Track />
      </div>
    </div>
  );
};
